module.exports = __webpack_public_path__ + "img/comment-smile.2ba9344f.svg";